module.exports = __webpack_public_path__ + "img/ArrowLeft.ff1fde49.svg";